import {
  SET_FILTER_TYPE,
  SET_FILTER_IDS,
  SET_SORT_BY,
  SET_SORT_DIRECTION,
  SET_PAGE,
  SET_PAGE_SIZE,
  RESET_FILTERS,
  FETCH_SETTINGS_SUCCESS,
} from './actionTypes';

const initialState = {
  filterType: null, // null=all users, 2=group
  filterIds: null, // Single group ID or null
  sortBy: 'name', // name, alertCount, completionPct, remainingDays
  sortDirection: 'asc', // asc, desc
  currentPage: 1,
  pageSize: 20,
};

const dailyBriefUiReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_FILTER_TYPE:
      return {
        ...state,
        filterType: action.payload,
        filterIds: null, // Reset filter ID when changing type
        currentPage: 1,
      };

    case SET_FILTER_IDS:
      return {
        ...state,
        filterIds: action.payload,
        currentPage: 1,
      };

    case SET_SORT_BY:
      return {
        ...state,
        sortBy: action.payload,
        currentPage: 1,
      };

    case SET_SORT_DIRECTION:
      return {
        ...state,
        sortDirection: action.payload,
        currentPage: 1,
      };

    case SET_PAGE:
      return {
        ...state,
        currentPage: action.payload,
      };

    case SET_PAGE_SIZE:
      return {
        ...state,
        pageSize: action.payload,
        currentPage: 1,
      };

    case RESET_FILTERS:
      return {
        ...initialState,
      };

    // Set defaults from settings when they load
    case FETCH_SETTINGS_SUCCESS:
      return {
        ...state,
        filterType: action.payload.defaultFilterType !== undefined
          ? action.payload.defaultFilterType
          : state.filterType,
        filterIds: action.payload.defaultFilterIds !== undefined
          ? action.payload.defaultFilterIds
          : state.filterIds,
        sortBy: action.payload.defaultSortBy || state.sortBy,
        sortDirection: action.payload.defaultSortOrder || state.sortDirection,
      };

    default:
      return state;
  }
};

export default dailyBriefUiReducer;
